import * as React from 'react'
import ReactSelect from 'react-select'
import { colors } from '../../../constants'

import Sizes from '../Input.sizes'

interface SelectOption {
    name?: string
    value?: string
}

interface SelectEvent {
    target: SelectOption
}

interface ReactSelectOption {
    label: string
    value: string
}

export interface InputSelectProps {
    borderColor?: string | boolean
    name?: string
    onChange?: (e: SelectEvent) => any
    ref: React.ForwardedRef<any>
    size?: Sizes
    value?: string
    values?: SelectOption[] | string[]
}

function InputSelect(props: InputSelectProps): JSX.Element {
    const { borderColor = undefined, name = undefined, onChange = () => undefined, size = Sizes.LG, value = '', values = [], ...rest } = props

    const options = values.map((v): ReactSelectOption => {
        if (typeof v === 'object') {
            return {
                value: v.value,
                label: v.name,
            } as ReactSelectOption
        }

        return {
            value: v,
            label: v,
        }
    })

    const customOnChange = (option: ReactSelectOption | null) => {
        // e.preventDefault();
        // e.stopPropagation();
        onChange({ target: { name, value: option?.value } })
    }

    const getWidth = () => {
        switch (size) {
            case Sizes.SM:
                return '115px;'
            case Sizes.MD:
                return '230px;'
            case Sizes.LG:
                return '400px;'
            case Sizes.NONE:
            default:
                return ''
        }
    }

    const customStyles = {
        container: (provided: any) => ({
            ...provided,
            width: getWidth(),
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            fontSize: '13.3333px',
            flexWrap: 'nowrap',
            minHeight: '27px',
            height: '25px',
            background: colors.greylightest,
            borderColor: borderColor || (state.isFocused ? colors.grey : colors.greylight),
            boxShadow: '0 0 transparent',
        }),
        menuPortal: (provided: any) => ({
            ...provided,
            zIndex: 9999,
        }),
        menu: (provided: any) => ({
            ...provided,
            background: colors.greylightest,
            zIndex: 9999,
            margin: 0,
        }),
        option: (provided: any) => ({
            ...provided,
            fontSize: '13px',
            padding: '4px 10px',
        }),
    }

    return (
        <ReactSelect
            styles={customStyles}
            menuPortalTarget={document.body}
            borderColor={borderColor}
            onChange={customOnChange}
            options={options}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: colors.grey,
                },
            })}
            value={options.filter((opt: ReactSelectOption): boolean => opt.value === value)}
            {...rest}
        ></ReactSelect>
    )
}

export default InputSelect
